import React, { useState, useEffect } from "react";
import "./ScrollToTopButton.css"; // styling alag file me

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Scroll hone par button visible
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    // Top par scroll karne ka function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            {isVisible && (
                <div className="scroll-to-top" onClick={scrollToTop}>
                    <span className="tooltip">Scroll to Top</span>
                    ↑
                </div>
            )}
        </>
    );
};

export default ScrollToTopButton;
